/**
 * Pure helpers for SceneItemsSection. Split out of the .tsx so the component
 * file exports React components only — Vite's `react-refresh` plugin needs
 * single-purpose exports for hot reload to work correctly.
 */

/**
 * Format a copper-piece value as GP/CP, mirroring the backend
 * `format_gold_amount` helper in `post_round_processing/display.rs`.
 * Used for the "Coins" scene item — `quantity` holds the loot pile's total
 * value in copper pieces (combat_end.rs aggregates monster `gold_cp` directly),
 * so displaying raw `x1300` reads as "1300 coins" when the actual value is
 * "13 GP" (per scenario 2026-05-12 B6).
 */
export function formatGoldFromCopper(goldCp: number): string {
  const safe = Math.max(0, Math.floor(goldCp));
  if (safe === 0) return '0 GP';
  const gp = Math.floor(safe / 100);
  const cp = safe % 100;
  if (gp > 0 && cp > 0) return `${gp} GP ${cp} CP`;
  if (gp > 0) return `${gp} GP`;
  return `${cp} CP`;
}

/**
 * Whether a scene item represents a coin pile (case-insensitive, matches the
 * backend's `name == "Coins"` aggregation in `combat_end.rs`).
 */
export function isCoinsItem(name: string): boolean {
  return name.toLowerCase() === 'coins';
}
